
import Countup from 'vux/src/components/countup/index.vue'

import { mapState, mapActions } from "vuex";
export default {
components: { Countup },
data() {
return {};
},
computed: {
...mapState({
accountBalance: (state) => state.userInfo.assetsInfoMap.accountBalance,
}),
},
methods: {
...mapActions(["getFirstInfo"]),
},
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/funds/components/balance.vue